import { EscapedString, html as svg } from '../c-mp/fun/html'
import type { ICouple } from '../model/ICouple'
import { formatDateShort } from './formatDateShort'
import { isDivorced } from './isDivorced'
import {
	FONT_SIZE_SMALL,
	ICON_MARGIN_X,
	ICON_SIZE,
	LABEL_RADIUS,
	LINE_HEIGHT,
	LINE_HEIGHT_SMALL,
} from './makeSvgTree'

export function drawMarriageLabel(
	test: SVGElement,
	content: (EscapedString | string)[],
	couple: ICouple,
	mx: number,
	my: number,
) {
	const y = my - LINE_HEIGHT / 2
	const isDivorce = isDivorced(couple)
	let labelWidth = ICON_SIZE + ICON_MARGIN_X * 2
	if (couple.marriedDate) {
		const label = svg`<text style="font-size: ${FONT_SIZE_SMALL}px">${formatDateShort(couple.marriedDate)}${isDivorce ? svg` – ${formatDateShort(couple.divorcedDate)}` : ''}</text>`
		test.innerHTML = label as string
		labelWidth +=
			ICON_MARGIN_X + test.firstElementChild!.getBoundingClientRect().width
	}
	const x = mx - labelWidth / 2
	if (couple.marriedDate) {
		content.push(
			svg`<rect
			x="${x}"
			y="${y}"
			width="${labelWidth}"
			height="${LINE_HEIGHT}"
			rx="${LABEL_RADIUS}"
			stroke="black"
			fill="white"
		/>`,
			svg`<use href="#${isDivorce ? 'divorce' : 'marriage'}" x="${x + ICON_MARGIN_X}" y="${y + 1}" />`,
			svg`<text
				x="${x + ICON_SIZE + ICON_MARGIN_X * 2}"
				y="${y + LINE_HEIGHT_SMALL}"
				style="font-size: ${FONT_SIZE_SMALL}px"
			><tspan>${formatDateShort(couple.marriedDate)}<title>${couple.marriedPlace ?? `Ismeretlen helyen`}</title></tspan>${
				isDivorce
					? svg` – <tspan>${formatDateShort(couple.divorcedDate)}<title>${couple.divorcedPlace ?? `Ismeretlen helyen`}</title></tspan>`
					: ''
			}</text>`,
		)
	} else {
		content.push(
			svg`<rect
			x="${x}"
			y="${y}"
			width="${labelWidth}"
			height="${LINE_HEIGHT}"
			rx="${LABEL_RADIUS}"
			stroke="black"
			fill="white"
		/>`,
			svg`<use href="#${isDivorce ? 'divorce' : 'marriage'}" x="${x + ICON_MARGIN_X}" y="${y + 1}" />`,
		)
	}
}
